import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FourSteps from './components/FourSteps';
import Destinations from './components/Destinations';
import Services from './components/Services';
import About from './components/About';
import Feedback from './components/Feedback';
import Newsletter from './components/Newsletter';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminPanel from './components/AdminPanel';
import PlanTrip from './components/PlanTrip';
import Blog from './components/Blog';
import './App.css';

function App() {
  const [showPlanTrip, setShowPlanTrip] = React.useState(false);
  
  // Check for secret admin key in URL hash or query parameter
  // Secret key: sefarium-admin-2024 (you can change this to anything you want)
  const [showAdminPanel, setShowAdminPanel] = React.useState(false);

  React.useEffect(() => {
    const checkAdminAccess = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(window.location.search);
      const secretKey = 'sefarium-admin-2024'; // Change this to your own secret key
      
      // Check hash: #admin-sefarium-admin-2024 or query: ?admin=sefarium-admin-2024
      if (hash === `#admin-${secretKey}` || params.get('admin') === secretKey) {
        setShowAdminPanel(true);
      } else {
        setShowAdminPanel(false);
      }
    };

    checkAdminAccess();
    
    // Listen for hash changes
    window.addEventListener('hashchange', checkAdminAccess);
    return () => window.removeEventListener('hashchange', checkAdminAccess);
  }, []);

  const HomePage = () => (
    <>
      <Hero />
      <Destinations />
      <FourSteps onDesignClick={() => setShowPlanTrip(true)} />
      <Services />
      <About />
      <Feedback />
      <Newsletter />
      <Contact />
    </>
  );

  return (
    <Router>
      <LanguageProvider>
        <AuthProvider>
          <div className="App">
            <Navbar />
            
            {showAdminPanel && (
              <AdminPanel onClose={() => {
                setShowAdminPanel(false);
                // Clear the hash/query when closing
                window.history.replaceState(null, '', window.location.pathname);
              }} />
            )}

            {showPlanTrip && (
              <PlanTrip onClose={() => setShowPlanTrip(false)} />
            )}

            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:city" element={<Blog />} />
            </Routes>
            
            <Footer />
          </div>
        </AuthProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;

